/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Rails Specific Code (UJS + Turbolinks)
var Turbolinks = require("turbolinks");
Turbolinks.start();
let ujs = require('rails-ujs');
ujs.start();

// Javascript Modules
import fonts        from './fonts';
import carousel     from './carousel';
import mobilenav    from './mobilenav';
import accordion    from './accordion';
import gallery    from './gallery';
// import navigation   from './navigation';

// Stylesheets
require('stylesheets/application.scss');

// Javascript
require('velocity-animate');

// Other
import fa from 'font-awesome/scss/font-awesome.scss';

document.addEventListener('turbolinks:load', function() {
  fonts.init();
  carousel.init();
  mobilenav.init();
  accordion.init();
  gallery.init();
  // navigation.init();
});
